<div class="cards">
  <div class="card-item" *ngFor="let card of cardsRodada">
    <card-primecap
      cardClass="rodadas-card"
      [cardRodada]="card"
      (clickButton)="redirecionarDetalhesCard()">
    </card-primecap>
  </div>
</div>
